var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 8V6.33333C7 5.74396 7.4999 4.91675 8 4.5C8.5001 4.08325 9.29276 4 10 4C10.7072 4 11.4999 4.08325 12 4.5C12.5001 4.91675 13 5.74396 13 6.33333V8H14V6.33333C14 4.49306 12.2083 3 10 3C7.79167 3 6 4.49306 6 6.33333V8H7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.0001H5V10.0001H5.46667H14.7778V9.00006H5.22222C4.89836 9.00096 4.58804 9.12165 4.35904 9.33579C4.13003 9.54992 4.00096 9.84009 4 10.1429V15.8572C4.00096 16.16 4.13003 16.4502 4.35904 16.6643C4.58804 16.8785 4.89836 16.9992 5.22222 17.0001H14.7778C15.1016 16.9992 15.412 16.8785 15.641 16.6643C15.87 16.4502 15.999 16.16 16 15.8572V10.1429H15V16.0001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7778 9.00006V10.0001L15 10.1429H16C16 10.1429 15.9962 9.66178 15.6914 9.33579C15.3654 8.98715 14.7778 9.00006 14.7778 9.00006Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass);
export default __webpack_public_path__ + "static/media/pass.b455ac071e736ccb7a3d9827d23b1fc4.svg";
export { ForwardRef as ReactComponent };